// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menu-item:hover .tools-pop-content[data-v-c489a7ae] {\n  display: block;\n}\n.menu-item .tools-pop-content[data-v-c489a7ae] {\n  display: none;\n}\n@keyframes opacity-c489a7ae {\nfrom {\n    opacity: 0.2;\n}\nto {\n    opacity: 1;\n}\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
